var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 120 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes colorChange {\n      0% {\n        stroke: black; \n      }\n      25% {\n        stroke: #9D89FC;\n      }\n      50% {\n        stroke: #9D89FC;\n      }\n      75% {\n        stroke: #FFFFFF;\n      }\n      100% {\n        stroke: black;\n      }\n    }\n\n    path {\n      animation: colorChange 4s infinite;\n      transition: stroke 0.3s ease-in-out;\n    }\n\n    path:nth-of-type(1) {\n      animation-delay: 1s; \n    }\n\n    path:nth-of-type(2) {\n      animation-delay: 0.5s;\n    }\n\n    path:nth-of-type(3) {\n      animation-delay: 0.5s;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8096 22.1027H112V80.6152H81.8096",
    stroke: "#011343",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4906 2L43.0557 96.616",
    stroke: "#011343",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1904 22.1027H4.00045V80.6152H34.1904",
    stroke: "#011343",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.73380f5a3c0ba2fa82d8603a95a7e8bb.svg";
export { ForwardRef as ReactComponent };